import { HttpRequest } from '@angular/common/http';
import { AsamcoAuthService } from '../auth/asamco-auth.service';
import { ServerSetting } from '../configuration/server-setting.interface';

/**
 * Gets the server settings based on the url
 * @param authService
 * @param url
 */
export function getServerSettingForRequest(authService: AsamcoAuthService, request: HttpRequest<any>): ServerSetting {
	if (authService.userSession == null) {
		return null;
	}

	const targetBackend = request.headers.get('X-Target-Backend');
	if(targetBackend) {
		const ss = authService.userSession.loggedInBackends.find(row => row.name === targetBackend);
		if(!ss) throw new Error(`Not logged into target backend '${targetBackend}'`);
		return ss;
	}

	// Try to get the backend which baseurl contains the request url
	let serverSettings = authService.userSession.loggedInBackends.find(row => request.url.includes(row.baseUrl));

	// If we still have no info, use the primary backend
	if (serverSettings == null) {
		serverSettings = authService.userSession.backend;
	}

	return serverSettings;
}
